export default __webpack_public_path__ + "static/media/img_fee_50.0514f428.svg";